import { render, staticRenderFns } from "./button-spinner.vue?vue&type=template&id=4fe6ef2a"
import script from "./button-spinner.vue?vue&type=script&lang=js"
export * from "./button-spinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/josh/CODE/king-living/king-living-outlet-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe6ef2a')) {
      api.createRecord('4fe6ef2a', component.options)
    } else {
      api.reload('4fe6ef2a', component.options)
    }
    module.hot.accept("./button-spinner.vue?vue&type=template&id=4fe6ef2a", function () {
      api.rerender('4fe6ef2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/button-spinner.vue"
export default component.exports